import { PostDeleteCompanionRequest } from 'src/sdk_checkin';
import { createAction, props } from '@ngrx/store';
import { asyncProps, FromApiActionPayload, WithRequestId, AsyncRequest } from '@lib';
import { CheckinDeleteCompanionResultModel } from './checkin-delete-companion-result.state';

/** StateDetailsActions */
const ACTION_SET = '[CheckinDeleteCompanionResult] set';
const ACTION_UPDATE = '[CheckinDeleteCompanionResult] update';
const ACTION_RESET = '[CheckinDeleteCompanionResult] reset';
const ACTION_FAIL = '[CheckinDeleteCompanionResult] fail';
const ACTION_CANCEL_REQUEST = '[CheckinDeleteCompanionResult] cancel request';

/** Async Actions */
const ACTION_SET_FROM_API = '[CheckinDeleteCompanionResult] set from api';
const ACTION_UPDATE_FROM_API = '[CheckinDeleteCompanionResult] update from api';

/**
 * Clear the current store object and replace it with the new one,
 * update isFailure to false, and update isPending with the boolean given as parameter if defined
 */
export const setCheckinDeleteCompanionResult = createAction(
  ACTION_SET,
  props<WithRequestId<CheckinDeleteCompanionResultModel>>()
);

/**
 * Change a part or the whole object in the store and update isFailure to false. The pendingUpdate boolean,
 * if set to true or false, will update the isPending property from the StateDetails
 */
export const updateCheckinDeleteCompanionResult = createAction(
  ACTION_UPDATE,
  props<WithRequestId<Partial<CheckinDeleteCompanionResultModel>>>()
);

/**
 * Clear the whole state, return to the initial one
 */
export const resetCheckinDeleteCompanionResult = createAction(ACTION_RESET);

/** Action to cancel a Request ID registered in the store. Can happen from effect based on a switchMap for instance */
export const cancelCheckinDeleteCompanionResultRequest = createAction(ACTION_CANCEL_REQUEST, props<AsyncRequest>());

/**
 * Update isPending from the StateDetails to false, and isFailure to true
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const failCheckinDeleteCompanionResult = createAction(ACTION_FAIL, props<WithRequestId<{ error: any }>>());

/**
 * Update isPending to true, triggers setFromApi Effect
 */
export const setCheckinDeleteCompanionResultFromApi = createAction(
  ACTION_SET_FROM_API,
  asyncProps<FromApiActionPayload<CheckinDeleteCompanionResultModel>>()
);

/**
 * Update isPending to true, triggers updateFromApi Effect
 */
export const updateCheckinDeleteCompanionResultFromApi = createAction(
  ACTION_UPDATE_FROM_API,
  asyncProps<FromApiActionPayload<CheckinDeleteCompanionResultModel>>()
);
